import { render, staticRenderFns } from "./PendingWithCaptain.vue?vue&type=template&id=0a0ac87c&scoped=true&"
import script from "./PendingWithCaptain.vue?vue&type=script&lang=js&"
export * from "./PendingWithCaptain.vue?vue&type=script&lang=js&"
import style0 from "./PendingWithCaptain.vue?vue&type=style&index=0&id=0a0ac87c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0ac87c",
  null
  
)

export default component.exports